export interface IPersonalAddressSetData {
  ownerIndex: number;
  runValidation: boolean;
  personalAddress: IPersonalAddressState;
  addressOnly?: boolean;
}

export interface IPersonalAddressGetData {
  personalAddress: IPersonalAddressState;
  validationStatus: string;
}

export interface Address {
  readonly street: string;
  readonly city: string;
  readonly zipCode: string;
  readonly state: string;
  readonly zipPlus4Code?: string;
  readonly defectReasonCode?: string;
  readonly addressLines?: Array<string>;
}

export interface IPersonalAddressState {
  mailingAddress: Address;
  streetAddress: Address;
  isStreetAddressSame: boolean;
  validationStatus: string;
  showValidation: boolean;
  clientAddresses: AllClientAddresses;
  isClientAddressesProcessing: boolean;
  isClientAddressesLoaded: boolean;
  mailingAddressDropdown: string;
  streetAddressDropdown: string;
  isContinueConfirmed: boolean;
}

export interface ClientAddress {
  readonly addressLines: Array<string>;
  readonly countryCode: string;
  readonly city: string;
  readonly state: string;
  readonly zipCode: string;
  readonly zipPlus4: string;
  readonly isPrimaryAddress: boolean;
  readonly isValidRPO: boolean;
  readonly isValidEscheat: boolean;
  readonly isMilitaryAddress: boolean;
  readonly isForeignAddress: boolean;
  readonly isDefaultMailing?: boolean;
  readonly addressType: string;
  readonly forDisplay: string;
  readonly comparator: string;
  readonly isPrimaryResidence?: boolean;
}
export interface AllClientAddresses {
  readonly mailingAddressesList: Array<ClientAddress>;
  readonly streetAddressesList: Array<ClientAddress>;
}
